import { images } from ".";
import cars from "./cars";

const events = [ 
    {
        id: 1,
        image: images.event1, // Replace with the actual event image
        title: "Vehicle Showcase",
        featuredCars: cars.slice(0, 3), // Show any three cars
        details: {
            date: "18 January, 2025", 
            time: "10:00 AM - 4:00 PM",
            location: "Main Showroom, New York",
            organizer: "Auto Enthusiasts Club",
            number: "+123-456-7890",
            email: "info@autoshowcase.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Join us at the Main Showroom in New York for an exclusive Vehicle Showcase. Discover the latest models, cutting-edge technology, and the future of automotive innovation.",
            "From luxury sedans to high-performance sports cars, this event is a must-visit for car enthusiasts and industry professionals alike."
        ],
        highlights: [
            "Latest car models",
            "Live vehicle demonstrations",
            "Test drive opportunities",
            "Meet top manufacturers",
            "Expert panel discussions"
        ],
        schedule: [
            "10:00 AM - Event Opening & Welcome",
            "11:30 AM - Luxury & Performance Models Showcase",
            "01:00 PM - Future of Automotive Tech",
            "02:30 PM - Interactive Test Drives",
            "03:30 PM - Industry Expert Q&A"
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.745632503296!2d-74.00597268459362!3d40.71277617932966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a3168729e03%3A0x6d0a0b2b15e364df!2sMain%20Showroom%2C%20New%20York!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus",
    },

    {
        id: 2,
        image: images.event2, // Replace with the actual event image
        title: "Seasonal Sales Event",
        featuredCars: cars.slice(0, 3), // Show any three cars
        details: {
            date: "23 February, 2025", 
            time: "9:00 AM - 9:00 PM",
            location: "Main Showroom, Chicago",
            organizer: "Auto Deals Network",
            number: "+123-456-7890",
            email: "info@autosales.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Don't miss the biggest Seasonal Sales Event of the year at the Main Showroom in Chicago! Explore unbeatable deals on the latest models, exclusive discounts, and limited-time offers.",
            "Whether you're looking for a new car, SUV, or truck, this event is the perfect opportunity to find your dream vehicle at the best price."
        ],
        highlights: [
            "Exclusive limited-time discounts",
            "Best financing & leasing offers",
            "Test drive the latest models",
            "Meet auto industry experts",
            "Special giveaways & promotions"
        ],
        schedule: [
            "09:00 AM - Event Kickoff & Welcome",
            "11:00 AM - Exclusive Discount Announcements",
            "02:00 PM - Test Drive Sessions",
            "05:00 PM - Auto Financing & Leasing Workshop",
            "07:30 PM - Special Giveaway Draw"
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.745632503296!2d-87.62979868459362!3d41.87811317932966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a3168729e03%3A0x6d0a0b2b15e364df!2sMain%20Showroom%2C%20Chicago!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus",
    },
    
    {
        id: 3,
        image: images.event3, // Replace with the actual event image
        title: "New Model Launch",
        featuredCars: cars.slice(0, 3), // Show any three latest models
        details: {
            date: "15 March, 2025", 
            time: "6:00 PM - 8:00 PM",
            location: "Luxury Auto Center, LA",
            organizer: "Luxury Auto Group",
            number: "+123-456-7890",
            email: "info@luxuryautola.com",
            fee: "Exclusive Invite Only"
        },
        paragraphs: [
            "Experience the unveiling of the latest luxury model at the prestigious Luxury Auto Center in LA. Witness cutting-edge design, unmatched performance, and innovative technology in a night of elegance and automotive excellence.",
            "Join industry experts, car enthusiasts, and VIP guests for an exclusive first look, networking opportunities, and live demonstrations."
        ],
        highlights: [
            "Exclusive first look at the new model",
            "Live performance demonstrations",
            "Meet automotive design experts",
            "Networking with industry professionals",
            "VIP test drive experience"
        ],
        schedule: [
            "6:00 PM - Welcome & Cocktail Reception",
            "6:30 PM - Unveiling Ceremony",
            "7:00 PM - Live Performance Demo",
            "7:30 PM - Exclusive Test Drive Sessions"
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d423286.27465972684!2d-118.6919203899216!3d34.020161287540334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2b69a21d9c3b7%3A0xf4f4a6e9a5f9a7fd!2sLuxury%20Auto%20Center%2C%20Los%20Angeles!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus",
    },
    
    {
        id: 4,
        image: images.event4, // Replace with the actual event image
        title: "Test Drive Event",
        featuredCars: cars.slice(0, 3), // Show any three test drive models
        details: {
            date: "08 April, 2025", 
            time: "8:00 AM - 5:00 PM",
            location: "Riverside Park, Dallas",
            organizer: "Dallas Auto Club",
            number: "+123-456-7890",
            email: "info@dallasautoclub.com",
            fee: "Free Registration Required"
        },
        paragraphs: [
            "Get behind the wheel and experience the thrill of driving the latest models at our exclusive Test Drive Event at Riverside Park, Dallas. Whether you're looking for speed, comfort, or fuel efficiency, we have a car for you!",
            "Join fellow car enthusiasts, meet auto experts, and test drive your dream car in a scenic outdoor setting."
        ],
        highlights: [
            "Test drive the latest car models",
            "Expert guidance & vehicle insights",
            "Exclusive leasing & financing offers",
            "Meet automotive specialists",
            "Family-friendly activities & giveaways"
        ],
        schedule: [
            "8:00 AM - Event Kickoff & Registration",
            "9:00 AM - First Test Drive Sessions",
            "12:00 PM - Expert Insights & Q&A",
            "2:00 PM - Special Leasing & Financing Offers",
            "4:00 PM - Final Test Drive Sessions"
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3354.516474636477!2d-96.79759218481928!3d32.77666498096813!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e987f16e21b45%3A0xabc123def456!2sRiverside%20Park%2C%20Dallas!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus",
    },    
    
    {
        id: 5,
        image: images.event5, // Replace with the actual event image
        title: "Maintenance Clinic",
        featuredCars: cars.slice(0, 3), // Show any three relevant models
        details: {
            date: "20 May, 2025", 
            time: "9:00 AM - 6:00 PM",
            location: "Service Center, Houston",
            organizer: "Houston Auto Care",
            number: "+123-456-7890",
            email: "info@houstonautocare.com",
            fee: "Free Workshop - Registration Required"
        },
        paragraphs: [
            "Join our exclusive Maintenance Clinic at the Houston Service Center and learn how to keep your vehicle in top shape. Get hands-on guidance from expert mechanics and discover essential car care tips.",
            "Whether you're a new car owner or a seasoned driver, this event will help you understand vehicle maintenance, diagnose common issues, and ensure your car runs smoothly for years to come."
        ],
        highlights: [
            "Hands-on vehicle maintenance training",
            "Learn essential car care tips",
            "Diagnose & fix common car issues",
            "Meet certified auto mechanics",
            "Exclusive discounts on maintenance services"
        ],
        schedule: [
            "9:00 AM - Welcome & Registration",
            "10:00 AM - Basic Car Maintenance 101",
            "12:00 PM - Engine & Battery Care",
            "2:00 PM - Troubleshooting Common Issues",
            "4:00 PM - Q&A with Auto Experts",
            "5:00 PM - Exclusive Service Discounts & Offers"
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3443.7894652233985!2d-95.36980248492358!3d29.7604269819829!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640bf3d7ebdc33b%3A0xabc123def456!2sService%20Center%2C%20Houston!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus",
    },    

    {
        id: 6,
        image: images.event6, // Replace with the actual event image
        title: "Electric Vehicle Expo",
        featuredCars: cars.filter(car => car.details.fuelType === "Electric").slice(0, 3),
        details: {
            date: "10 June, 2025", 
            time: "11:00 AM - 5:00 PM",
            location: "Green Auto Expo, Seattle",
            organizer: "Green Auto Alliance",
            number: "+123-456-7890",
            email: "info@greenautoexpo.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Join us at the Green Auto Expo for an exclusive look at the future of electric vehicles. Explore the latest innovations, meet industry leaders, and experience eco-friendly transportation like never before.",
            "From cutting-edge EV models to sustainable automotive solutions, this event is perfect for car enthusiasts and environmental advocates alike."
        ],
        highlights: [
            "Latest electric vehicle models",
            "Charging infrastructure insights",
            "Test drive eco-friendly cars",
            "Meet top EV manufacturers",
            "Exclusive panel discussions"
        ],
        schedule: [
            "11:00 AM - Opening Keynote",
            "12:00 PM - EV Model Showcase",
            "01:30 PM - Future of Charging Tech",
            "03:00 PM - Test Drive Sessions",
            "04:30 PM - Expert Panel Q&A"
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2689.503709283387!2d-122.33516798437116!3d47.60972297918519!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5490102a4e1a9a6b%3A0x2b0a4c5f367f7f82!2sSeattle%20Convention%20Center!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus",
    }

    
];

export default events;